import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFineLinesGlyphSecondary from './svgs/FineLinesGlyphSecondary.js';
import SvgFineLinesGlyph from './svgs/FineLinesGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var fineLinesGlyph = (props => useIcon(SvgFineLinesGlyph, SvgFineLinesGlyphSecondary, props));

export { fineLinesGlyph as default };
